const footer = (state = {
  genre: [], year: [], country: [], id: '',
}, action = {}) => {
  switch (action.type) {
    case 'FOOTER_PARAMS_GENRE':
      return {
        genre: action.genre,
        year: state.year,
        country: state.country,
        id: `${action.genre.join(',')}|${state.year.join(',')}|${state.country.join(',')}`,
      };
    case 'FOOTER_PARAMS_YEAR':
      return {
        genre: state.genre,
        year: action.year,
        country: state.country,
        id: `${state.genre.join(',')}|${action.year.join(',')}|${state.country.join(',')}`,
      };
    case 'FOOTER_PARAMS_COUNTRY':
      return {
        genre: state.genre,
        year: state.year,
        country: action.country,
        id: `${state.genre.join(',')}|${state.year.join(',')}|${action.country.join(',')}`,
      };
    default:
      return state;
  }
};
export default footer;
